const navigationCategoryMapping = {
  "/pages/about-zymo-research": "about",
  "/pages/scientific-advisory-board": "about",
  "/pages/25-anniversary": "about",
  "/pages/iso-certification": "about",
  "/pages/events": "about",
  "/pages/netsuite-returns-form-image-viewer": "about",
  "/pages/privacy-policy": "about",
  "/pages/special-offers": "about",
  "/pages/terms-of-purchase": "about",
  "/pages/terms-and-conditions": "about",
  "/pages/trademarks": "about",
  "/pages/contact": "about",
  "/pages/faq": "about",
  "/pages/quick-order": "how-to-order",
  "/pages/how-to-order": "how-to-order",
  "/pages/our-distributors": "how-to-order",
  "/pages/custom-manufacturing-solutions": "how-to-order",
  "/pages/oem-sample-collection-devices": "how-to-order",
  "/pages/all-products": "products",
  "/pages/stool-collector-device": "products",
  "/pages/covid-19-efforts": "products",
  "/pages/directdetect": "products",
  "/pages/direct-zol-rna-purification-kits": "products",
  "/pages/gut-microbiome-standard": "products",
  "/pages/hmw-dna-purification": "products",
  "/pages/16s-library-prep": "products",
  "/pages/microbiome-standards": "products",
  "/pages/mix-and-go-competent-cells": "products",
  "/pages/molecular-transport-media-mtm": "products",
  "/pages/quick-rna": "products",
  "/pages/quick-sars-cov-2-multiplex-kit": "products",
  "/pages/quick-sars-cov-2-rrt-pcr": "products",
  "/pages/quick-viral-covid-19": "products",
  "/pages/rcc": "products",
  "/pages/rna-kits": "products",
  "/pages/rrbs-dna-methylation-profiling": "products",
  "/pages/safecollect": "products",
  "/pages/safecollect-inquiry-page": "products",
  "/pages/safe-covid-19-shipping": "products",
  "/pages/sample-storage-ambient-temperature": "products",
  "/pages/select-a-size-magbead-kit": "products",
  "/pages/shield-510k": "products",
  "/pages/bisulfite-conversion-kits": "products",
  "/pages/quick-dna-environmental-kits": "products",
  "/pages/tag-spin": "products",
  "/pages/total-rna-seq-library-prep": "products",
  "/pages/what-is-trizol": "resources",
  "/pages/zymobiomics-dna-rna-kits": "products",
  "/pages/zymobiomics-fecal-reference-with-trumatrix-technology": "products",
  "/pages/zymo-environ-water-rna-kit": "products",
  "/pages/zymopure": "products",
  "/pages/bisulfite-beginner-guide": "resources",
  "/pages/bisulfite-primer-seeker": "resources",
  "/pages/citations": "resources",
  "/pages/certificate-of-analysis": "resources",
  "/pages/color-for-charity": "resources",
  "/pages/controls-for-dna-methylation-app-note": "resources",
  "/pages/tips-for-biopharma-research-study": "resources",
  "/pages/considerations-for-choosing-a-dtc-fecal-collection-device": "resources",
  "/pages/building-accurate-shotgun-metagenomic-workflow": "resources",
  "/pages/gated-page-consider-before-launching-dtc-microbiome-test": "resources",
  "/pages/gated-page-maximizing-the-rna-seq-library-and-data-quality-via-quality-control-of-input-total-rna": "resources",
  "/pages/microbiome-shotgun-service-promotion": "resources",
  "/pages/gated-page-sample-collection-methods-in-covid-19-testing-sequencing-research": "resources",
  "/pages/subscription-based-business-models-for-direct-to-consumer-testing": "resources",
  "/pages/getting-the-most-plasmid-dna": "resources",
  "/pages/green-solution-initiative": "resources",
  "/pages/guide-for-choosing-a-microbiome-standard": "resources",
  "/pages/considerations-for-direct-to-consumer-sampling-application": "resources",
  "/pages/illumina-covidseq": "resources",
  "/pages/impact-initiative-grant": "resources",
  "/pages/how-to-increase-yield-of-low-copy-number-plasmids": "resources",
  "/pages/liquid-biopsy-wgbs-aacr-poster": "resources",
  "/pages/literature": "resources",
  "/pages/maximizing-quality-rna-seq-libraries-app-note": "resources",
  "/pages/wildlife-grant": "resources",
  "/pages/m-sci": "resources",
  "/pages/multi-organism-transcriptomics-app-note": "resources",
  "/pages/share-your-research": "resources",
  "/pages/tools": "resources",
  "/pages/tradeshow-send-info": "resources",
  "/pages/video-library": "resources",
  "/pages/webinars": "resources",
  "/pages/what-is-dna-methylation": "resources",
  "/pages/what-is-epigenetics": "resources",
  "/pages/what-is-rna-seq": "resources",
  "/pages/chip-seq": "services",
  "/pages/covid19-variant-sequencing-service": "services",
  "/pages/dnage": "services",
  "/pages/genome-wide-dna-methylation-analysis": "services",
  "/pages/human-dnage": "services",
  "/pages/inquiry-confirmation": "services",
  "/pages/microbiome-analysis-services": "services",
  "/pages/microbiome-service-submission-form": "services",
  "/pages/microbiomics-services-referred": "services",
  "/pages/mouse-dnage": "services",
  "/pages/rna-seq-analysis-services": "services",
  "/pages/services": "services",
  "/pages/service-submission-form": "services",
  "/pages/service-submission-terms-of-service": "services",
  "/pages/shotgun-metagenomic-sequencing-service": "services",
  "/pages/targeted-bisulfite-sequencing": "services",
  "/pages/16s-its-amplicon-sequencing": "services",
  "/pages/dreamprep-nap-workstation": "resources",
  "/pages/zymobiomics-portfolio": "resources",
  "/pages/zymobiomics-services-referred": "services",
  "/pages/zymo-environ-covid-19-wastewater-testing-service": "services",
  "/pages/automation": "automation",
  "/pages/hamilton-automation": "automation",
  "/pages/tecan-automation": "automation",
  "/pages/opentrons-automation": "automation",
  "/pages/magnetic-bead-automation": "automation",
  "/pages/automation-form": "automation",
  "/pages/new-lab-start-up-program": "about",
  "/pages/full-length-16s-sequencing-service": "services",
  "/pages/empowering-discovery-tools-to-master-the-microbiome": "resources",
  "/pages/fecal-solutions": "products",
  "/pages/magicbead-cfdna-isolation-kit": "products",
  "/pages/empowering-discovery-tools-to-master-the-microbiome-non-gated": "resources",
  "/pages/popular-products-and-services": "products",
  "/pages/sample-collection-kits": "products",
  "/pages/epilift": "products",
  "/pages/long-read-metagenomic-sequencing-assembly": "services",
  "/pages/innovative-technologies-for-transcriptomics": "services",
  "/pages/30-year-anniversary-yeast": "about",
  "/pages/purerec-rnase-a": "products",
  "/pages/30-year-anniversary-zymo-spin": "about",
  "/pages/microbiome-custom-solutions": "services",
  "/pages/metatranscriptomic-sequencing-services": "services",
};